var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinkBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20888_36362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7799 34.1H22.9399V74.37H72.7799V34.1Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.31 34.1H13.24V74.37H15.31V34.1Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3901 34.1H80.3201V74.37H82.3901V34.1Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.83 25.28H4.79004V27.35H90.83V25.28Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7699 81.12H7.8999V83.19H87.7699V81.12Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8099 89.1H4.88989V91.17H90.8099V89.1Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4399 18.54L47.4599 5.47C47.5799 5.42 47.7199 5.39 47.8599 5.39C47.9999 5.39 48.1399 5.42 48.2599 5.47L78.2699 18.53H17.4399V18.54Z",
    fill: "#C4D3CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8601 72.01C47.6601 72.01 47.4701 71.97 47.2901 71.9C38.6301 68.55 32.8101 59.65 32.8101 49.75V45.18C32.8101 44.62 33.1101 44.1 33.5901 43.82L47.0501 35.81C47.3001 35.66 47.5801 35.59 47.8601 35.59C48.1401 35.59 48.4301 35.67 48.6701 35.81L62.1301 43.82C62.6101 44.1 62.9101 44.63 62.9101 45.18V49.75C62.9101 59.65 57.0901 68.55 48.4301 71.9C48.2501 71.97 48.0501 72.01 47.8601 72.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.85 19L50.41 0.529999C48.78 -0.170001 46.94 -0.170001 45.32 0.529999L2.87 19C1.13 19.76 0 21.48 0 23.39V27.12C0 29.76 2.14 31.9 4.79 31.9H7.98V76.57C5.34 76.57 3.19 78.71 3.19 81.36V84.84C1.29 85.51 0 87.31 0 89.33V92.52C0 94.29 1.43 95.71 3.19 95.71H92.53C94.29 95.71 95.72 94.28 95.72 92.52V89.33C95.72 87.31 94.43 85.51 92.53 84.84V81.36C92.53 78.72 90.39 76.57 87.74 76.57V31.9H90.93C93.57 31.9 95.72 29.76 95.72 27.11V23.38C95.72 21.48 94.59 19.75 92.85 18.99V19ZM46.58 3.45C47.39 3.1 48.32 3.1 49.13 3.45L88.84 20.73H6.88L46.58 3.45ZM11.17 31.9H17.55V76.57H11.17V31.9ZM20.74 76.57V31.9H74.98V76.57H20.74ZM92.53 92.52H3.19V89.33C3.19 88.45 3.9 87.73 4.79 87.73H90.94C91.82 87.73 92.54 88.44 92.54 89.33V92.52H92.53ZM89.34 81.35V84.54H6.38V81.35C6.38 80.47 7.09 79.75 7.98 79.75H87.74C88.62 79.75 89.34 80.46 89.34 81.35ZM84.55 76.56H78.17V31.9H84.55V76.57V76.56ZM90.93 28.7H4.79C3.91 28.7 3.19 27.99 3.19 27.1V23.91H92.53V27.1C92.53 27.98 91.82 28.7 90.93 28.7Z",
    fill: "#3A404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4401 59.32C45.0201 59.32 44.6201 59.15 44.3201 58.86L41.7101 56.25C41.0901 55.63 41.0901 54.62 41.7101 54C42.0101 53.7 42.4101 53.54 42.8301 53.54C43.2501 53.54 43.6501 53.71 43.9501 54L45.4401 55.49L51.7601 49.17C52.0601 48.87 52.4601 48.7 52.8801 48.7C53.3001 48.7 53.7001 48.87 54.0001 49.17C54.3001 49.47 54.4601 49.87 54.4601 50.29C54.4601 50.71 54.2901 51.11 53.9901 51.41L46.5501 58.85C46.2501 59.15 45.8501 59.31 45.4301 59.31L45.4401 59.32Z",
    fill: "#3A404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8601 72.01C47.6601 72.01 47.4701 71.97 47.2901 71.9C38.6301 68.55 32.8101 59.65 32.8101 49.75V45.18C32.8101 44.62 33.1101 44.1 33.5901 43.82L47.0501 35.81C47.3001 35.66 47.5801 35.59 47.8601 35.59C48.1401 35.59 48.4301 35.67 48.6701 35.81L62.1301 43.82C62.6101 44.1 62.9101 44.63 62.9101 45.18V49.75C62.9101 59.65 57.0901 68.55 48.4301 71.9C48.2501 71.97 48.0501 72.01 47.8601 72.01ZM35.9801 49.75C35.9801 58.07 40.7501 65.67 47.8601 68.71C54.9701 65.67 59.7401 58.08 59.7401 49.75V46.08L47.8601 39.01L35.9801 46.08V49.75Z",
    fill: "#3A404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8599 8.44C45.5499 8.44 43.6699 10.32 43.6699 12.63C43.6699 14.94 45.5499 16.82 47.8599 16.82C50.1699 16.82 52.0499 14.94 52.0499 12.63C52.0499 10.32 50.1699 8.44 47.8599 8.44ZM47.8599 14.73C46.6999 14.73 45.7599 13.79 45.7599 12.63C45.7599 11.47 46.6999 10.53 47.8599 10.53C49.0199 10.53 49.9599 11.47 49.9599 12.63C49.9599 13.79 49.0199 14.73 47.8599 14.73Z",
    fill: "#3A404A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20888_36362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.72,
    height: 95.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinkBank);
export default __webpack_public_path__ + "static/media/tink_bank.a9810840c10d4f500e0e70bbc120c4e6.svg";
export { ForwardRef as ReactComponent };